export interface IAbsenceReasonCategory {
    value: string;
    label: string;
}

// Reason "Sonstige Fehlzeit (bitte Begründung angeben)" from lzk_reasonForAbsence.
export const ReasonIsOtherAbsenceId: string = "938b782c-8c9b-4795-8d6b-298c317427f4";

// Reason "Krankmeldung" — still uses a free text comment, unlike the reason above.
export const ReasonIsSickNoteId: string = "b58c03d7-6dc9-45e2-8cd9-b0dd64edc8de";

// Categories offered instead of a free text comment when "Sonstige Fehlzeit" is selected.
// Value and label are identical because the selected value is persisted verbatim into the
// existing free text column `reasonComment`, which every other system reads as plain text.
export const absenceReasonCategories: Array<IAbsenceReasonCategory> = [
    {
        value: "Private Gründe",
        label: "Private Gründe"
    },
    {
        value: "Gesundheitliche Gründe",
        label: "Gesundheitliche Gründe"
    },
    {
        value: "Technik",
        label: "Technik"
    },
    {
        value: "Mobilität",
        label: "Mobilität"
    },
    {
        value: "Keine Angabe",
        label: "Keine Angabe"
    },
    {
        value: "Urlaub",
        label: "Urlaub"
    },
];

// Existing entries may hold arbitrary free text written before the categories existed.
// Such a value is offered as an additional option so it is displayed correctly and kept
// unless the user actively picks a category.
export const buildAbsenceReasonCategoryOptions = (storedComment: string): Array<IAbsenceReasonCategory> => {
    const isKnownCategory = absenceReasonCategories.some((category) => category.value === storedComment);

    return storedComment === "" || isKnownCategory
        ? absenceReasonCategories
        : [{ value: storedComment, label: storedComment }, ...absenceReasonCategories];
};
